var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return this.currentAnsiSegment && this.currentAnsiSegment.speed_limit_value
    ? _c(
        "div",
        {
          staticClass: "speed-limit-container",
          attrs: { title: "Speed Limit" },
        },
        [
          _c("div", { staticClass: "black-outline" }, [
            _c("div", { staticClass: "speed-limit-number-container" }, [
              _c(
                "div",
                {
                  staticClass: "speed-limit-number",
                  class:
                    _vm.speedLimitLength == 1
                      ? "large-font"
                      : _vm.speedLimitLength == 2
                      ? "medium-font"
                      : _vm.speedLimitLength >= 3
                      ? "small-font"
                      : null,
                },
                [_vm._v(_vm._s(_vm.currentAnsiSegment.speed_limit_value))]
              ),
              _vm._v(" "),
              _c("h6", [_vm._v("KMH")]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }